import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=dd5f8bde&scoped=true&"
import script from "./VHeader.vue?vue&type=script&lang=js&"
export * from "./VHeader.vue?vue&type=script&lang=js&"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=dd5f8bde&lang=scss&scoped=true&"
import style1 from "./VHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5f8bde",
  null
  
)

export default component.exports